







































































































































































































































































































































import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import StudioMobileMenu from '@/web/components/navigation/StudioMobileMenu.vue';
import StudioMobileProfileMenu from '@/web/components/navigation/StudioMobileProfileMenu.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import StudioLogo from '@/web/components/navigation/StudioLogo.vue';
import StudentLogin from '@/web/components/signup/StudentLogin.vue';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import { isOfficialDomain, replaceURLWithCurrentDomain } from '@/web/utils/url';
import CommunityNotifications from '@/web/components/community/CommunityNotifications.vue';
import { mixin as clickaway } from 'vue-clickaway';
import { isTouchDevice } from '@/web/utils/detect-device';

export default Vue.extend({
  name: 'StudioTopBar',
  mixins: [clickaway],
  components: {
    StudioMobileMenu,
    StudioMobileProfileMenu,
    NavItem,
    StudioLogo,
    CommunityNotifications,
  },
  data() {
    return {
      selectedPageName: null,
      displayLarge: false,
      showPopoverMenu: false,
      showNotifications: false,
      //numberOfMessages: 1, // hardcoded till server's changes
    };
  },
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
      isLoggedIn: 'user/isLoggedIn',
      teacherMagicCode: 'user/teacherMagicCode',
      studentMagicCode: 'user/studentMagicCode',
      numberOfThisStudioPunches: 'user/numberOfThisStudioPunches',
      numberOfNotifications: 'community/numberOfNotifications',
      numberOfStudioNotifications: 'community/numberOfStudioNotifications',
      numberOfChatNotifications: 'community/numberOfChatNotifications',
      interactAsStudio: 'community/interactAsStudio',
    }),
    ...mapState('user', ['user', 'teacher']),
    notificationsCount() {
      return this.interactAsStudio
        ? this.numberOfStudioNotifications
        : this.numberOfNotifications;
    },
    getBaseFrontendURL() {
      const host = window.location.host.toLowerCase();
      if (isOfficialDomain(host)) {
        return replaceURLWithCurrentDomain(window.location.origin);
      }

      return process.env.VUE_APP_FRONTEND_BASE_URL;
    },
    dashboardLink() {
      return `${this.getBaseFrontendURL}dashboard?magic_code=${this.teacherMagicCode}`;
    },
    userName() {
      if (!this.user) return '';
      return (
        this.user.student?.first_name || this.$t('GENERAL.LABEL.ANONYMOUS')
      );
    },
    studioURL() {
      return getStudioURL(this.$route);
    },
    showLogin() {
      return !this.isLoggedIn && this.selectedPageName !== 'studio-login';
    },
  },
  methods: {
    openMainNav() {
      this.$store.dispatch('globals/openMainNav');
    },
    openStudioMobileProfileMenu() {
      this.$store.dispatch('globals/openStudioMobileProfileMenu');
    },
    getNotificationsStyle() {
      const notificationsTrigger = this.$refs.notificationsTrigger;
      if (!notificationsTrigger) return {};
      const boundingRect = notificationsTrigger.getBoundingClientRect();
      if (boundingRect.left - 380 > 0) {
        return {
          left: `${Math.max(boundingRect.left - 380, 0)}px`,
        };
      } else {
        return {
          right: `1px`,
        };
      }
    },
    hideNotifications() {
      this.showNotifications = false;
    },
    openLoginModal() {
      this.$modal.show(StudentLogin, {
        onLoginFn: () => {
          // redirect from home page to studio/student dashboard if on home page
          const redirectToDashboard =
            ['studio-home', 'studio-signup'].indexOf(this.$route.name) !== -1;
          if (redirectToDashboard) {
            this.$router.push({ name: 'studio-dashboard' });
          }
        },
      });
    },
    onScroll() {
      if (isTouchDevice()) {
        this.displayLarge = false;
      } else {
        this.displayLarge = window.scrollY < 100;
      }
    },
    logout() {
      this.showPopoverMenu = false;
      const currentRoute = this.$router.currentRoute;
      if (currentRoute.matched.some(record => record.meta.requiresAuth)) {
        this.$router.push({ name: 'studio-logout' });
      } else this.$store.dispatch(`user/logout`);
    },
    onNotificationIconClick() {
      this.showNotifications = !this.showNotifications;
    },
    onMessageIconClick() {
      this.$router.push({ name: 'studio-community-chat' });
    },
  },
  created() {
    this.selectedPageName = this.$router.currentRoute.name;
  },
  watch: {
    $route({ name }) {
      this.selectedPageName = name;
      this.showNotifications = false;
    },
  },
  mounted() {
    document.addEventListener('scroll', this.onScroll);
    this.onScroll();
  },
  destroyed() {
    document.removeEventListener('scroll', this.onScroll);
  },
});
